import config from 'volta/config/environment';

const {
  APP: { version }
} = config;

const key = 'volta:app:version';

export const clearLocalStorage = () => {
  const { localStorage } = window;

  if (localStorage && localStorage.getItem(key) !== version) {
    localStorage.clear();
    localStorage.setItem(key, version);
  }
};
